import React from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";

import routes from "routes.js";

import logo from "assets/img/falcons.png";
import { BackgroundColorContext } from "contexts/BackgroundColorContext";
import { useAuth } from "contexts/AuthContext";

var ps;

function Admin(props) {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();
  const mainPanelRef = React.useRef(null);
  const [sidebarOpened, setsidebarOpened] = React.useState(
    document.documentElement.className.indexOf("nav-open") !== -1
  );
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(mainPanelRef.current, {
        suppressScrollX: true,
      });
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps = new PerfectScrollbar(tables[i]);
      }
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      document.documentElement.classList.add("perfect-scrollbar-off");
      document.documentElement.classList.remove("perfect-scrollbar-on");
    };
  });
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      let tables = document.querySelectorAll(".table-responsive");
      for (let i = 0; i < tables.length; i++) {
        ps = new PerfectScrollbar(tables[i]);
      }
    }
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainPanelRef.current) {
      mainPanelRef.current.scrollTop = 0;
    }
  }, [location]);
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setsidebarOpened(!sidebarOpened);
  };
  const getRoutes = (routes, parentPath = "") => {
    return routes.flatMap((prop, key) => {
      if (prop.subRoutes) {
        // Registrar las subrutas como rutas individuales
        return getRoutes(prop.subRoutes, prop.path);
      }
      if (prop.layout === "/admin") {
        return [
          <Route
            path={parentPath + prop.path}
            element={prop.component}
            key={parentPath + prop.path}
          />,
        ];
      }
      return [];
    });
  };
  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      const route = routes[i];
      if (route.subRoutes) {
        for (let j = 0; j < route.subRoutes.length; j++) {
          const sub = route.subRoutes[j];
          if (location.pathname.indexOf(route.layout + route.path + sub.path) !== -1) {
            return sub.name;
          }
        }
      }
      if (location.pathname.indexOf(route.layout + route.path) !== -1) {
        return route.name;
      }
    }
    return "FALCONS";
  };
  return (
    <BackgroundColorContext.Consumer>
      {({ color, changeColor }) => (
        <React.Fragment>
          <div className="wrapper">
            <Sidebar
              routes={routes}
              logo={{
                innerLink: "/admin/dashboard",
                text: "Academia FALCONS",
                imgSrc: logo,
              }}
              toggleSidebar={toggleSidebar}
            />
            <div className="main-panel" ref={mainPanelRef} data={color} style={{ overflowX: 'hidden', overflowY: 'auto' }}>
              <AdminNavbar
                brandText={getBrandText(location.pathname)}
                toggleSidebar={toggleSidebar}
                sidebarOpened={sidebarOpened}
              />
              <Routes>
                {getRoutes(routes)}
                <Route
                  path="/"
                  element={<Navigate to="/admin/dashboard" replace />}
                />
              </Routes>
              {
                // we don't want the Footer to be rendered on map page
                location.pathname === "/admin/maps" ? null : <Footer fluid />
              }
            </div>
          </div>
          <FixedPlugin bgColor={color} handleBgClick={changeColor} />
        </React.Fragment>
      )}
    </BackgroundColorContext.Consumer>
  );
}

export default Admin;
